var exports = {
  "Mt": "PlanCard__uK1US-",
  "qQ": "PlanCard__label__lxQWdM",
  "ni": "PlanCard__content__0fn71O",
  "vz": "PlanCard__titleBlock__DpfmT7",
  "xr": "PlanCard__price__JAY2Cc",
  "vx": "PlanCard__priceTag__ontH76",
  "J0": "PlanCard__ctaBlock__DEOSjv",
};

module.exports = exports;
